import { postV1, getV1, delV1 } from '@/common/utils/ajax'

const getFollowsMessages = (params) => getV1('user_messages', params)

const getFollowsActicle = (params) => getV1('feeds', params)

const getFollows = (params) => getV1('follows', params)

const setFollows = (params) => postV1('follows', params)

const delFollows = (params) => delV1('follows/0', params)

export default {
    setFollows,
    getFollows,
    getFollowsMessages,
    getFollowsActicle,
    delFollows
}